/* import __COLOCATED_TEMPLATE__ from './homepage-style-selector-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const HomepageStyleSelectorRow = dt7948.c(class HomepageStyleSelectorRow extends SelectKitRowComponent {}, [classNames("homepage-style-selector-row")]);
export default HomepageStyleSelectorRow;